
import { Component, Vue, Watch } from 'vue-property-decorator';
import ModalDefaultPopup from '@/components/ModalDefaultPopup.vue';
import { StateApiError } from '@/store/modules/error';

@Component({
  components: {
    ModalDefaultPopup
  }
})
export default class Modal extends Vue {
  private currentApiError: StateApiError | null = null;
  private isOpenBack: boolean = false;
  private isOpenPopup: boolean = false;

  private get apiErrorList(): StateApiError[] {
    return this.$store.getters['error/apiErrorList'];
  }

  @Watch('apiErrorList')
  handleOpen(error: Error[]): void {
    if (this.currentApiError) return;
    this.currentApiError = this.apiErrorList.length > 0 ? this.apiErrorList[0] : null;
    if (this.currentApiError) {
      if (this.currentApiError.type === 'redirect') {
        // 致命的なエラーの場合はエラーページへ飛ぶ
        this.$store.dispatch('error/removeApiError', this.currentApiError);
        this.$router.replace({ name: 'application-error', params: { code: this.currentApiError.code } });

        this.currentApiError = null;
      } else {
        this.isOpenBack = true;
        this.isOpenPopup = true;
      }
    }
  }

  private onClickOK(): void {
    if (!this.currentApiError) return;
    this.onCloseStart(this.currentApiError.type === 'retry');
  }

  private onClickNG(): void {
    if (!this.currentApiError) return;
    this.onCloseStart(false);
  }

  private onClickBack(): void {
    if (!this.currentApiError) return;
    if (this.currentApiError.type === 'retry') return;
    this.onCloseStart(false);
  }

  // ポップアップを閉じ始める時の処理
  private onCloseStart(isRetry: boolean): void {
    // ポップアップを閉じる
    this.isOpenPopup = false;
    // 別のエラーが存在しない場合は背景を閉じる
    const isCloseBack: boolean = this.apiErrorList.every(
      (error: StateApiError): boolean => this.currentApiError === error
    );
    if (isCloseBack) this.isOpenBack = false;

    // ポップアップを閉じ終わった時の処理を設定
    this.$once('onCloseEnd', (): void => {
      if (!this.currentApiError) return;
      this.$store.dispatch('error/removeApiError', this.currentApiError);

      let isFatal: boolean = false;
      if (this.currentApiError.type === 'retry' && !isRetry) isFatal = true;
      if (isFatal) {
        // 致命的なエラーの場合はエラーページへ飛ぶ
        this.$router.replace({ name: 'application-error', params: { code: this.currentApiError.code } });
      } else {
        // 掴んでいたエラーを離す
        this.currentApiError.next(isRetry);
      }

      // ポップアップ処理を終える
      this.currentApiError = null;
    });
  }

  // ポップアップを閉じ終わった時の処理
  private onCloseEnd(): void {
    this.$emit('onCloseEnd');
  }
}
